import { selectCardStep, successStep, naStep } from "./sagas/your-credit-card/your-credit-card-steps";
export var yourCreditCardFlow = {
  steps: [selectCardStep, successStep, naStep]
};